module.exports = __webpack_public_path__ + "img/img_left.3fa2e17b.jpg";